
const
    // 引入公共函数
    Util = require('../../../common/util'),

    // 引入订单页面主模板
    orderMain = require('../templates/orderMain.ejs'),

    // 引入入住信息结构
    guestMsg = require('../templates/guestMessage.ejs'),

    // 验价请求
    isHotelOnline = require('./sendRequest.js').isHotelOnline,

    //初始化日历价格
    getCanlendarPrice = require('./sendRequest.js').getCanlendarPrice,

    // 获取初始化信息
    getInitData = require('./sendRequest.js').getInitData,

    //跳转到指定页面的函数
    changeToPage = require('./commonTools.js').changeToPage,

    //初始化日历价格天数
    addDays = Util.addDays,

    //获取url的参数
    queryString = Util.queryString,

    // 关闭窗口的函数（兼容各个浏览器）
    CloseWebPage = require('./commonTools.js').CloseWebPage;



// 开始初始化页面（先判断酒店是否在线）
function initPage() {
    isHotelOnline(function (res) {

        if (typeof res === 'string') {
            res = window.JSON.parse(res);
        }

        if (res.returnCode === 1){
            $.validateIsComplete = 'true';
        } else if (res.returnCode === -400001){
            //将标识的值变为false，表示有错误信息
            $.validateIsComplete = 'false';
            alert('请先登录', { closeBtn: 0 }, function () {
                //跳转到首页
                location.href = '/user/bookHotel.do?';
            });
        } else {
            //将标识的值变为false，表示有错误信息
            $.validateIsComplete = 'false';
            //否则就提示用户错误信息，然后跳转到酒店详情页面
            alert(res.errinfo, { closeBtn: 0 }, function () {
                changeToPage();
            });
        }
    });
    //请求各个接口，并将返回的数据经模板处理后再填充页面（初始化页面）
    invokeAPIs();
}

// 请求各个接口，并将返回的数据经模板处理后再填充页面（初始化页面）
function invokeAPIs(initHtml) {

    let days = addDays(queryString('today'));

    // 获取日历价格
    getCanlendarPrice(days,function (res) {
      if(res.returnCode === 1 ){
        let dateArr = [];
        let daysArr = [];
        let dayObj = {};
        if(res.data){
          for(let key in res.data){
            dayObj = {
              key : key,
              val : res.data[key].length
            };
            dateArr.push(dayObj);
            daysArr.push(res.data[key].length)
          }
          dateArr.sort(function (a,b) {
            return Date.parse(a.key) - Date.parse(b.key)
          });
          if(daysArr.indexOf(1)>=0){
            // 获取订单初始信息，并填充到页面
            for(let key in dateArr){
              if(dateArr[key].val == 1){
                  getOrderInitData(dateArr[key].key, res.data[dateArr[key].key][0]);
                return;
              }
            }
          }else {
            getCanlendarPrice(addDays(days,31,'-'),function (res) {
              if(res.returnCode ===1){
                if(res.data ){
                  for(let key in res.data){
                    dayObj = {
                      key : key,
                      val : res.data[key].length
                    };
                    dateArr.push(dayObj);
                    daysArr.push(res.data[key].length)
                  }
                  dateArr.sort(function (a,b) {
                    return Date.parse(a.key) - Date.parse(b.key)
                  });
                  if(daysArr.indexOf(1)>=0){
                    // 获取订单初始信息，并填充到页面
                    for(let key in dateArr){
                      if(dateArr[key].val == 1){
                        getOrderInitData(dateArr[key].key, res.data[dateArr[key].key][0]);
                        return;
                      }
                    }
                  }else {
                    alert('暂无门票价格价格',function () {
                      changeToPage();
                    });
                  }

                }
              }else if(res.returnCode === -400001){
                alert('请先登录', { closeBtn: 0 }, function () {
                  //跳转到首页
                  location.href = '/user/bookHotel.do?';
                });
              }else {
                alert(res.errinfo,function () {
                  changeToPage();
                })
              }
            })
          }

        }
      }else if(res.returnCode === -400001){
        alert('请先登录', { closeBtn: 0 }, function () {
          //跳转到首页
          location.href = '/user/bookHotel.do?';
        });
      }else {
        alert(res.errinfo,function () {
          changeToPage();
        })
      }
    });



}


function getValidateTag(errorMsg, newPrcie) {
    var checkValidate = setInterval(function () {
        var validateIsComplete = $.validateIsComplete;

        if (validateIsComplete) {
            clearInterval(checkValidate);
            if (validateIsComplete !== 'false') {
                if (errorMsg === 'isAveragePriceRMBChange'){
                    let priceChange = layer.confirm(
                        '最新价格为：￥' + newPrcie + '，是否需要继续预订？',
                        function () {
                            layer.close(priceChange);
                        },
                        function () {
                            changeToPage();
                        }
                    );

                }else{
                    alert(errorMsg, { closeBtn: 0 }, function () {
                      changeToPage();
                    });
                }
            }
        }
    }, 100);
}


// 获取订单初始信息，并填充到页面
function getOrderInitData(day, params) {

  getInitData(day, params, function (res) {


        if(res.returnCode === 1 ){
            // 将返回结果存入全局变量，以便后续取用

          $.orderInfo = res;

          res.data.distributorAccount.paymentTermName = ["客人前台现付", '单结', '周结', '半月结', '月结', '不固定', '三日结', '十日结', '额度结'];

            $('.t-o-c-ticket-user').html(orderMain({data:res.data}));

            $('.t-o-c-ticket-needKnow').html(guestMsg({data:res.data}));

            $('#ticketCalenderPrice').val(addDays(day,0,'-'));

            // 异步加载插件（验证插件、日期插件），这个过程依赖 $.orderInfo
            loadScriptsAsync();

        } else {
            getValidateTag(res.errinfo);
        }
    });
}


// 异步加载插件（验证插件、日期插件）
function loadScriptsAsync() {

    // IE9以下和IE9以上的浏览器采用不同方式加载插件（日期控件、验证控件）
    if (Util.ltIE9()) {

        // 引入页面主交互逻辑
        const initActive = require('./initActive.js').run;

        Util.loadAsync(
            [
                // '../../webpacked/static/js/datePick/datepickPacked.js',
                '../../webpacked/static/js/validator/validatorPacked.js'
            ],
            initActive
        );

    } else {

        require.ensure([], function () {

            // 引入页面主交互逻辑
            const initActive = require('./initActive.js').run;

            // require('../../../static/js/datePick/datepickPacked');
            require('../../../static/js/validator/validatorPacked');

            initActive();

        }, 'validator');
    }
}



module.exports =  {
    run :initPage,
    invokeAPIs:invokeAPIs
};



// WEBPACK FOOTER //
// ./src/js/ticketOrderConfirm/modules/initPage.js